/**
 * Helpers to build canonical mesh prop objects for roundedRectangle and nineSlice
 * so we can compare and cache them reliably.
 */
export function buildRoundedRectangleMeshProps(wrapperProps, sw, sh, compScaling) {
    var _a, _b, _c, _d, _e, _f;
    return {
        sw,
        sh,
        rounding: ((_a = wrapperProps.rounding) !== null && _a !== void 0 ? _a : 30) * compScaling[0],
        resolution: (_b = wrapperProps.resolution) !== null && _b !== void 0 ? _b : 4,
        tl: (_c = wrapperProps.roundTopLeft) !== null && _c !== void 0 ? _c : true,
        tr: (_d = wrapperProps.roundTopRight) !== null && _d !== void 0 ? _d : true,
        bl: (_e = wrapperProps.roundBottomLeft) !== null && _e !== void 0 ? _e : true,
        br: (_f = wrapperProps.roundBottomRight) !== null && _f !== void 0 ? _f : true,
    };
}
export function buildNineSliceProps(wrapperProps, sw, sh, compScaling) {
    var _a, _b;
    return {
        sw,
        sh,
        borderTextureSize: (_a = wrapperProps.borderTextureSize) !== null && _a !== void 0 ? _a : 0,
        borderSize: ((_b = wrapperProps.borderSize) !== null && _b !== void 0 ? _b : 0) * compScaling[0],
    };
}
